import React from "react";
import { Box } from "@mui/material";
import Field from "../shared/Field";
import ItemCard from "../shared/ItemCard";
import AddItemBtn from "../shared/AddItemBtn";
import ImageUploadField from "../../../../components/ImageUploadField";

const FormFaq = ({ data, onChange }) => {
  const updateItem = (i, field, value) => {
    const items = [...data.items];
    items[i] = { ...items[i], [field]: value };
    onChange({ ...data, items });
  };

  const addItem = () =>
    onChange({ ...data, items: [...data.items, { question: "", answer: "" }] });

  const removeItem = (i) => {
    if (data.items.length <= 1) return;
    onChange({ ...data, items: data.items.filter((_, idx) => idx !== i) });
  };

  return (
    <Box>
      <Field
        label="Section Title"
        value={data.sectionTitle}
        onChange={(v) => onChange({ ...data, sectionTitle: v })}
      />
      <ImageUploadField
        label="Illustration Image (left side)"
        value={data.imageUrl}
        onChange={(v) => onChange({ ...data, imageUrl: v })}
      />
      {data.items.map((item, i) => (
        <ItemCard
          key={i}
          index={i}
          label="Question"
          onDelete={() => removeItem(i)}
        >
          <Field
            label="Question"
            value={item.question}
            onChange={(v) => updateItem(i, "question", v)}
            placeholder="What type of applications do you develop?"
          />
          <Field
            label="Answer"
            value={item.answer}
            onChange={(v) => updateItem(i, "answer", v)}
            multiline
            placeholder="We build web applications for e-commerce, SaaS..."
          />
        </ItemCard>
      ))}
      <AddItemBtn label="Add FAQ" onClick={addItem} />
    </Box>
  );
};

export default FormFaq;
